import type { UnifiedTransaction } from '../../hooks/users/query/V2/mappers';

// The same raw fields PaginationTable's built-in local search covered via the
// searchable transaction columns. The rows are cursor-paged now, so the page
// filters its accumulated rows itself (the table's localSearch is off to keep
// server sort order).
const SEARCHED_FIELDS = [
  'created',
  'userName',
  'type',
  'amount',
  'status',
  'description',
] as const;

export function matchesTransactionSearch(
  transaction: UnifiedTransaction,
  term: string
): boolean {
  const needle = term.toLowerCase().trim();
  if (!needle) return true;
  return SEARCHED_FIELDS.some((field) => {
    const value = transaction[field];
    return value != null && value.toString().toLowerCase().includes(needle);
  });
}
